// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  data: [],
};

// getters
const getters = {
  ...BaseModule.getters,
  all(state, getters, rootState, rootGetters) {
    return state.data;
  },
  find_by_address(state, getters, rootState, rootGetters) {
    return (city, street) => {
      return state.data.filter(gym => {
        return gym.city === city && gym.street === street;
      })[0];
    };
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  fetch_all ({state, commit, dispatch, getters, rootState}, payload) {
      return dispatch('api/getEndpoint', {
        endpoint: '/gyms'
      }, {root: true}).then(response => {
        commit('set_state', {property: 'data', value: response.data.data});
      });
  },
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  // dummy_mutation (state, id) {
  //     state.id = id;
  // },
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
};
